export enum EUserProfilePreferenceType {
  PAGE_SIZE_DROPDOWN = 'PageSize Dropdown',
  BOOLEAN = 'Boolean',
}

export enum EUserProfilePreferenceAttributeName {
  COLLAPSE_T1_QUICK_NAV = 'CollapseT1QuickNav',
  T1_LIST_PAGE_SIZE = 'T1ListPageSize',
  T2_LIST_PAGE_SIZE = 'T2ListPageSize',
  T3_LIST_PAGE_SIZE = 'T3ListPageSize',
  T4_LIST_PAGE_SIZE = 'T4ListPageSize',
  DT_LIST_PAGE_SIZE = 'DTListPageSize',
  ST_LIST_PAGE_SIZE = 'STListPageSize',
  CT_LIST_PAGE_SIZE = 'CTListPageSize',
  RT_LIST_PAGE_SIZE = 'RTListPageSize',
  PROJECT_LIST_PAGE_SIZE = 'ProjectListPageSize',
  DOCUMENT_REGISTER_LIST_PAGE_SIZE = 'DocumentRegisterListPageSize',
  HIDE_TRANSMITTAL_REMOVED_FROM_USE_ITEM = 'HideTransmittalRemovedFromUseItems',
  HIDE_PROJECT_LIST_ARCHIVED_PROJECTS = 'HideProjectListArchivedProjects',
}
